export const getPreviousYears = (numOfYears) => {
  const date = new Date()
  const thisYear = date.getFullYear() + 1
  let years = []
  for (let index = 0; index < numOfYears; index++) {
    years[years.length] = (thisYear - index).toString()
  }
  return years
}
